<ngx-loading [show]="showSpinner || !iwService.handshakeFinished"></ngx-loading>
<div class="card bounceInRight animated" style="width: 430px;margin: 3rem auto;">
  <div class="card-body">
    <div class="circle-gray top"><i class="fa fa-user"></i></div>
    <br>
    <form [formGroup]="inviteForm" (ngSubmit)="onSubmit()" *ngIf="userAccount">
      <div class="form-group" *ngIf="!(invite?.isPatient)">
        <label class="form-control-label" for="Organization" required>{{ 'inviteRegistration.organization' |
          translate}}</label><span style="color:red"> * </span>
        <input type="text" class="form-control" id="Organization" name="Organization" formControlName="Organization"
          readonly>
      </div>

      <div class="form-group">
        <label class="form-control-label" for="UserEmail" required>{{ 'inviteRegistration.email' |
          translate}}</label><span style="color:red"> * </span>
        <input type="email" class="form-control" id="UserEmail" name="UserEmail" formControlName="UserEmail" readonly>
      </div>

      <div class="form-group">
        <label class="form-control-label" for="Name" required>{{ 'inviteRegistration.name' | translate}}</label><span
          style="color:red"> *
        </span>
        <input type="text" class="form-control" id="Name" name="Name" formControlName="Name" readonly>
      </div>
        <div class="form-group">
        <label class="form-control-label" for="SystemAccountIdSintra" required>{{ 'inviteRegistration.systemAccountIdSintra' |
          translate}}</label><span style="color:red"> * </span>
        <input type="text" class="form-control" id="SystemAccountIdSintra" name="SystemAccountIdSintra" formControlName="SystemAccountIdSintra"
          readonly>
      </div>

      <div class="row">
        <div *ngIf="!iwService.handshakeFinished" class="mb-2 ml-3">
          {{ 'login.handShakeLoginWaitText' | translate }}
        </div>
        <div *ngIf="waitAMinute" class="mb-2 ml-3">
          {{ 'login.waitAMinute' | translate }}
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-8" *ngIf="associatedDID == false">
            <app-button [disable]="submitting || !iwService.handshakeFinished"
                        title="{{'inviteRegistration.register' | translate}}" primary="true" big="true" (buttonClick)="onSubmit()">
            </app-button>
        </div>
        <div class="col-md-12" *ngIf="associatedDID == true">
          <app-button [disable]="submitting || !iwService.handshakeFinished"
                      title="{{'inviteRegistration.register' | translate}}" primary="true" big="true" (buttonClick)="onSubmit()">
          </app-button>
      </div>
        <div class="col-md-2"></div>
      </div>
    </form>
  </div>
</div>